export default store => {
  return {
    async getAlbum(params) {
      return await store.dispatch(`albums/fetch`, {
        type: "album",
        params
      });
    },
    async getEditingAlbum(params) {
      return await store.dispatch(`albums/fetch`, {
        type: "editing",
        params
      });
    },
    async getReviewAlbum(params) {
      return await store.dispatch(`albums/fetch`, {
        type: "review",
        params
      });
    },
    async getAlbumTracks(params) {
      return await store.dispatch(`albums/tracks`, {
        params
      });
    },
    async getAlbums(params) {
      return await store.dispatch(`albums/fetch`, {
        params
      });
    },
    async getPopularAlbums(params) {
      return await store.dispatch("albums/fetch", {
        type: "popular",
        params
      });
    },
    async getLatestAlbums(params) {
      return await store.dispatch("albums/fetch", {
        type: "latest",
        params
      });
    },
    async getFavoriteAlbums(params) {
      return await store.dispatch("albums/fetch", {
        type: "favorite",
        params
      });
    },
    async getReleatedAlbums(params) {
      return await store.dispatch(`albums/fetch`, {
        type: "releated",
        params
      });
    }
  };
};
